import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import { useContext } from 'react'
import { AuthContext } from '../utils/context/auth.context'

export interface PageProps {
  children: React.ReactNode
  sx?: SxProps<Theme> // Style override
}

// Base page component
const Page = ({ children, sx }: PageProps) => {
  const { authenticated } = useContext(AuthContext)
  return (
    <Box
      sx={{
        ...sx,
        padding: '24px',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        backgroundColor: 'var(--color-sidebar)',
        borderRadius: 'var(--radius-2xl)',
        borderWidth: '1px',
        borderColor: 'var(--color-border)',
      }}
    >
      {authenticated && children}
    </Box>
  )
}

export default Page
